<div class="text-center">
     <button
        class="btn btn-sm btn-custom-pri" id="{{idString}}-settingsBtn-{{params.rowIndex}}"
        style="vertical-align: baseline; font-size: 12px;" (click)="handleActionClickEvent('settings')"><i
            class="fa-solid fa-gear fa-fw"></i>
    </button>
</div>